/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Api_Reference_Errors_TitleInputs */

const en_directory_api_reference_errors_title = /** @type {(inputs: Directory_Api_Reference_Errors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error codes`)
};

const zh_directory_api_reference_errors_title = /** @type {(inputs: Directory_Api_Reference_Errors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误码`)
};

/**
* | output |
* | --- |
* | "Error codes" |
*
* @param {Directory_Api_Reference_Errors_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_api_reference_errors_title = /** @type {((inputs?: Directory_Api_Reference_Errors_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Api_Reference_Errors_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_api_reference_errors_title(inputs)
	return zh_directory_api_reference_errors_title(inputs)
});
export { directory_api_reference_errors_title as "directory.api_reference.errors_title" }